import RemaindersReport from './RemaindersReport.redux';

export default RemaindersReport;
